import { IMaskMixin } from 'react-imask';
import { IonInput } from '@ionic/react';
import classNames from 'classnames';
import { useContext, useContextSelector } from 'use-context-selector';

import { FieldPatternContext } from '../FieldPattern.context';
import { LocalizationContext } from '../../../../../src/contexts/LocalizationContext';

import styles from '../../Fields.module.scss';

export const FieldPatternMasked = IMaskMixin<HTMLIonInputElement>(
  ({ inputRef }) => {
    const datepicker = useContextSelector(
      LocalizationContext,
      ({ form: { datepicker } }) => datepicker
    );

    const {
      error,
      onBlur,
      invalid,
      placeholder,
      enterKeyHint,
      disabled,
      onFocus,
      onKeyUp,
      onKeyDown,
      onCompositionUpdate,
    } = useContext(FieldPatternContext);

    return (
      <IonInput
        fill="outline"
        ref={inputRef}
        disabled={disabled}
        onIonBlur={onBlur}
        onIonFocus={onFocus}
        labelPlacement="stacked"
        errorText={error}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        enterkeyhint={enterKeyHint}
        onCompositionUpdate={onCompositionUpdate}
        placeholder={placeholder || datepicker.format}
        className={classNames(styles.input, {
          'ion-invalid': invalid,
          'ion-touched': invalid,
        })}
      />
    );
  }
);
